export const QUIZ_TYPE_MULTIPLE_CHOICE = 'MULTIPLE_CHOICE';
export const QUIZ_TYPE_DIS_DAT = 'DIS_DAT';

export const DisDatType = Object.freeze({
    CROSS_ENTITY_MUSICAL_GROUP_VS_MUSICAL_GROUP: 'CROSS_ENTITY_MUSICAL_GROUP_VS_MUSICAL_GROUP',
    CROSS_ENTITY_MUSICIAN_VS_MUSICIAN: 'CROSS_ENTITY_MUSICIAN_VS_MUSICIAN',
    MUSICAL_GROUP_ALBUM_VS_ALBUM: 'MUSICAL_GROUP_ALBUM_VS_ALBUM',
    MUSICAL_GROUP_MEMBER_VS_MEMBER: 'MUSICAL_GROUP_MEMBER_VS_MEMBER',
    MUSICIAN_ALBUM_VS_ALBUM: 'MUSICIAN_ALBUM_VS_ALBUM',
    CUSTOM: 'CUSTOM'
});
